import React from "react";

const VehicleCardAlt = ({
  carID,
  carName,
  tags = [],
  image,
  totalReceived,
  roi,
  totalValue,
  location,
  progress,
}) => {
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "#1e1e1e",
        color: "#fff",
        borderRadius: "10px",
        overflow: "hidden",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        width: "calc(100% - 40px)", // Matches the search bar width
        maxWidth: "930px", // Optional max-width
        margin: "10px auto",
        height: "120px", // Thinner height
      }}
    >
      {/* Image Section */}
      <div style={{ flex: "0 0 150px", position: "relative" }}>
        <img
          src={image || "https://via.placeholder.com/150"}
          alt={carName}
          style={{
            width: "160%",
            height: "100%",
            objectFit: "contain",
            borderRadius: "15px",
            marginLeft: "8px",
          }}
        />
      </div>

      {/* Details Section */}
      <div
        style={{
          flex: "1",
          padding: "10px 15px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          marginLeft: "95px",
        }}
      >
        <div>
          <h3
            style={{
              margin: "0 0 5px 0",
              fontSize: "1.5em",
              fontWeight: "bold",
            }}
          >
            {carName}
          </h3>
          <p style={{ margin: "0", fontSize: "0.9em", color: "#ccc" }}>
            {location || "Unknown"}
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p style={{ margin: "0", fontSize: "0.9em" }}>
            <strong>Total Value:</strong> ${totalValue?.toLocaleString() || "0"}
          </p>
          <p style={{ margin: "0", fontSize: "0.9em" }}>
            <strong>Total Received:</strong>{" "}
            ${totalReceived?.toLocaleString() || "0"}
          </p>
        </div>

        {/* Progress Bar */}
        <div
  style={{
    backgroundColor: "#333",
    borderRadius: "5px",
    overflow: "hidden",
    height: "10px",
    marginTop: "5px",
  }}
>
  <div
    style={{
      width: `${parseFloat(progress || 0).toFixed(2)}%`,
      backgroundColor: "#32B704",
      height: "100%",
      transition: "width 0.3s ease",
    }}
  />
</div>
<p style={{ margin: "5px 0 0", fontSize: "0.9em", color: "#ccc" }}>
  {parseFloat(progress || 0).toFixed(2)}% Funded
</p>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          flex: "0 0 150px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          padding: "10px",
        }}
      >
        <button
          style={{
            width: "100px",
            padding: "10px",
            backgroundColor: "#32B704",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onClick={() => {
            // Navigate to the investment page for this car
            window.location.href = `/cars/${carID}`;
          }}
        >
          Invest
        </button>
        <button
          style={{
            width: "100px",
            padding: "10px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onClick={() => {
            // Navigate to the rental page for this car
            window.location.href = `/rental/${carID}`;
          }}
        >
          Rent
        </button>
      </div>
    </div>
  );
};

export default VehicleCardAlt;
